import { request } from "util/api/client";
import { takeEvery, put, select } from "redux-saga/effects";
import { pending } from "state/actions/ui";
import { handleResponse } from "state/sagas/api";
import { selectEntity } from "state/selectors/data";

function* handleSyncIntegrationTags({ context, payload }) {
    const { id, apply } = payload;
    try {
        yield put(pending(id, true));
        const url = apply
            ? `cms/integrations/${id}/sync-tags`
            : `cms/integrations/${id}/sync-tags-status`;
        const integration = yield select((store) =>
            selectEntity(store, "cms.integrations", id)
        );
        const data = {};
        if (integration.project_id) data.project_id = integration.project_id;
        if (integration.tags_entry_types)
            data.tags_entry_types = integration.tags_entry_types;
        const response = yield request({
            method: "post",
            url,
            context,
            data,
        });
        yield handleResponse(payload, response);
        yield put(pending(id, false));
    } catch (e) {
        yield put(pending(id, false));
    }
}

export default function* () {
    yield takeEvery("CMS.INTEGRATIONS.SYNC_TAGS", handleSyncIntegrationTags);
}
